export default __webpack_public_path__ + "static/media/146722.7ef529f3.jpg";